// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"3d57c419","382":"e80a206f","453":"e003726f","551":"8c1f44c4"}[chunkId] + ".chunk.js";
};